import ParentClass from './Parent.js';

class Search extends ParentClass {
  constructor() {
    super();
    const moduleClass = '.page-search-results';
    if(!super.runThisModule(moduleClass)) return;

    const $viewMoreBtn = $('#search-results--view-more-btn');
    const numArticlesToDisplay = 5;
    if( $viewMoreBtn.length ){
        // On click, display numArticlesToDisplay articles
        $viewMoreBtn.on('click', function(ev){
            ev.preventDefault();
            $('.search-results-container article').filter(".d-none").slice(0, numArticlesToDisplay).removeClass('d-none');

            // If there are no more 'article' with class '.d-none', then hide the viewMoreBtn
            if( $('.search-results-container article.d-none').length === 0 ){
                $(this).addClass('d-none');
            }
        });
    }
  }
}

jQuery(document).ready(function() {
    new Search();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/Search.js